export function assertNever(_value: never, message: string) {
    console.error(message);
}

export const IS_DEV = process.env.NODE_ENV === "development";

export const GOOGLE_MAPS_API_KEY = IS_DEV ? "AIzaSyAZoVaVd-UusGFRuSZ6ympu7LlhXDDcZkU" : "AIzaSyCsV8UFRAk9xWczzRn_p2Ul0OOl3pp1nc0";
